import { toInteger } from 'lodash';
import type { ISize } from '@/version-types';

// 添加图层时的尺寸自动计算规则
export function getAddLayerSize(stageSize: ISize): ISize {
    const { width: stageWidth, height: stageHeight } = stageSize;
    const stageRatio = stageWidth / stageHeight;
    const ratio = 1;

    let width = 0;
    let height = 0;

    if (stageRatio > ratio) {
        height = toInteger(stageHeight / 2);
        width = height;
    } else {
        width = toInteger(stageWidth / 2);
        height = width;
    }

    return {
        width,
        height,
    };
}
